import { render } from "./Disaster.vue?vue&type=template&id=4547f2d4&scoped=true&ts=true"
import script from "./Disaster.ts?vue&type=script&lang=ts"
export * from "./Disaster.ts?vue&type=script&lang=ts"

import "./Disaster.scss?vue&type=style&index=0&id=4547f2d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4547f2d4"]])

export default __exports__